/**
 * SessionsPageV2 — redesigned shell for the Sessions list.
 *
 * Renders directly inside AuthLayoutV2's <main> (no MainContentContainer
 * wrapper). The redesigned shell already provides the bg color and the
 * 244px sidebar offset, so the page just stacks: <PageHeader> on top,
 * <SessionsTableV2> below.
 *
 * Per-page search is intentionally absent — the global ⌘K command palette
 * (mounted at the layout level in CommandPalette.jsx) replaces it.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import SessionsTableV2 from '../../SessionsTable/v2/SessionsTableV2';
import { PageHeader, Button } from '../../redesign';

/** Plus glyph for the coral "New session" button — same inline mark as the
 *  prototype's `<span class="plus">+</span>`. */
const PlusSign = (
  <span style={{ fontSize: 16, lineHeight: 1 }} aria-hidden>+</span>
);

export default function SessionsPageV2() {
  return (
    <div className="bg-bg min-h-full">
      <PageHeader
        eyebrow="Content Library"
        title="Sessions"
        actions={
          <Link to="/sessions/add" className="no-underline">
            <Button variant="coral" leadingIcon={PlusSign}>New session</Button>
          </Link>
        }
      />
      <SessionsTableV2 />
    </div>
  );
}
